<template>
  <ATable
    ref="table"
    :data="items"
    hideButtonExcel
    hide-button-insert
    hide-pagination
    highlightCurrentRow
    border
    @cell-click="handleCellClick"
  >
    <div slot="search">
      <div class="list-title">{{ title }}{{ parentName }}</div>
    </div>
    <el-table-column
      type="index"
      label="No"
      prop="index"
      :width="$width.index"
      :index="handleIndex"
    />
    <el-table-column
      prop="name"
      :width="nameWidth"
      label="계정명"
      show-overflow-tooltip
    >
      <template slot-scope="scope">
        <span v-if="scope.row.id === editingId">
          <el-input size="mini" v-model="scope.row.name" />
        </span>
        <span v-else>
          {{ scope.row.name }}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="비고" prop="desc" show-overflow-tooltip>
      <template slot-scope="scope">
        <span v-if="scope.row.id === editingId">
          <el-input size="mini" v-model="scope.row.desc" />
        </span>
        <span v-else>
          {{ scope.row.desc }}
        </span>
      </template>
    </el-table-column>
    <el-table-column prop="use_flag" width="50" label="사용">
      <template slot-scope="scope">
        <span v-if="scope.row.id === editingId">
          <ACheckboxYN v-model="scope.row.use_flag" />
        </span>
        <span v-else>
          <i class="el-icon-check" v-show="scope.row.use_flag === 'Y'" />
        </span>
      </template>
    </el-table-column>
    <el-table-column label="명령" width="150" v-if="has_grant_write">
      <template slot-scope="scope">
        <div v-if="scope.row.id === editingId">
          <el-button
            type="primary"
            size="mini"
            @click="handleClickedRegister(scope.row)"
            >저장</el-button
          >
          <el-button size="mini" @click="calcelEditing(scope.row)"
            >취소</el-button
          >
        </div>
        <div v-else>
          <el-button size="mini" @click="handleClickedModify(scope.row)"
            >수정</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="handleClickDelete(scope.row)"
            >삭제</el-button
          >
        </div>
      </template>
    </el-table-column>
    <div slot="buttons">
      <el-button
        type="primary"
        :disabled="disable_insert || !has_grant_write"
        @click="handleClickedCreate"
        >{{ title }} 추가</el-button
      >
    </div>
  </ATable>
</template>

<script>
export default {
  name: "AssetCategoryTable",
  data() {
    return {
      editingId: -1,
      oldItem: undefined,
      deleteData: undefined,
    };
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    items: {
      default: [],
    },
    disable_insert: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Object,
    },
    nameWidth: {
      type: Number,
      default: 250,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.items.length < 1) {
        return;
      }
      let item = this.items[0];
      this.$refs.table.setCurrentRow(item);
      this.$emit("select", item);
    });
  },
  destroyed() {
    if (this.editingId < 0) {
      return;
    }
    this.calcelEditing(this.oldItem);
    this.editingId = -1;
  },
  computed: {
    parentName() {
      if (!this.parent) return "";
      return " [" + this.parent.name + "]";
    },
  },
  methods: {
    calcelEditing(data) {
      let index = this.items.findIndex((i) => i.id === data.id);
      if (this.oldItem.id) {
        this.items.splice(index, 1, this.oldItem);
      } else {
        this.items.splice(index, 1);
      }
      this.editingId = -1;
    },
    doDelete() {
      this.$emit("delete", this.deleteData);
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleCellClick(item, column) {
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      if (!column.property) {
        return;
      }
      this.$emit("select", item);
    },
    handleClickedCreate() {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = 0;
      this.oldItem = { id: 0, name: "", desc: null, use_flag: "Y" };
      const items = [...this.items];
      items.push(this.oldItem);
      this.items = items;
    },
    handleClickedModify(item) {
      if (this.editingId > -1) {
        this.calcelEditing(this.oldItem);
      }
      this.editingId = item.id;
      this.oldItem = Object.assign({}, item);
    },
    handleClickDelete(data) {
      this.deleteData = data;
      this.util.confirm_delete(
        this,
        this.title + "[" + data.name + "]",
        this.doDelete
      );
    },
    handleClickedRegister(data) {
      let isDuplicated = false;
      if (data.name.trim() === "") {
        this.util.notify_warning(this, this.title, "계정명을 입력해주세요.");
        return;
      }
      this.items.forEach((item) => {
        if (item.id !== data.id && item.name === data.name) {
          isDuplicated = true;
        }
      });
      if (isDuplicated) {
        this.util.notify_warning(this, this.title, "중복된 계정명입니다.");
        return;
      }
      if (this.parent) {
        data.parent_id = this.parent.id;
      }
      this.editingId = -1;
      this.oldItem = null;
      this.$emit("register", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.column {
  width: 49%;
  &:not(:last-child) {
    margin-right: 20px;
  }
}
.detail-container {
  height: 420px;
}
</style>
